export default __webpack_public_path__ + "static/media/OUTLND-Banner.0148c38b.png";